import React from "react";

const statusMeta = {
  pass: { icon: "✓", label: "PASS", color: "#81c784" },
  warn: { icon: "⚠", label: "WARN", color: "#ffcc80" },
  fail: { icon: "✕", label: "FAIL", color: "#ffb4ab" },
  pending: { icon: "…", label: "RUNNING", color: "#90caf9" },
  unknown: { icon: "?", label: "UNKNOWN", color: "#a1acb7" },
};

const styles = {
  row: {
    display: "grid",
    gridTemplateColumns: "160px 96px minmax(0, 1fr)",
    gap: "12px",
    alignItems: "start",
    padding: "12px 0",
    borderBottom: "1px solid rgba(255,255,255,0.12)",
  },
  label: {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "0.9rem",
  },
  status: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: 800,
    fontSize: "0.8rem",
  },
  message: {
    color: "#ffffff",
    fontSize: "0.9rem",
    lineHeight: 1.35,
    overflowWrap: "anywhere",
  },
  detail: {
    color: "#a1acb7",
    fontSize: "0.78rem",
    lineHeight: 1.35,
    marginTop: "4px",
    overflowWrap: "anywhere",
    whiteSpace: "pre-wrap",
  },
};

export const DiagnosticStatusRow = ({ label, status, message, detail }) => {
  const meta = statusMeta[status] || statusMeta.unknown;

  return (
    <div style={styles.row}>
      <div style={styles.label}>{label}</div>
      <div style={{ ...styles.status, color: meta.color }}>
        <span aria-hidden="true">{meta.icon}</span>
        <span>{meta.label}</span>
      </div>
      <div>
        <div style={styles.message}>{message}</div>
        {detail ? <div style={styles.detail}>{detail}</div> : null}
      </div>
    </div>
  );
};
